import { TIERS, getTier, PILLARS } from '../utils/scoring';

export default function TierProgression({ currentScore, scores }) {
  const currentTier = getTier(currentScore);
  const currentIdx = TIERS.indexOf(currentTier);

  // Find weakest pillars (biggest improvement opportunity)
  const sortedPillars = [...PILLARS]
    .map(p => ({ ...p, score: scores[p.id]?.score || 0 }))
    .sort((a, b) => a.score - b.score);

  const weakest = sortedPillars.slice(0, 3);

  return (
    <div className="card p-6">
      <h3 className="font-bold text-white text-lg mb-1">Score Progression Path</h3>
      <p className="text-xs text-navy-400 mb-5">Your roadmap from {currentTier.name} to the next level</p>

      {/* Tier ladder */}
      <div className="space-y-2 mb-6">
        {[...TIERS].reverse().map((tier, i) => {
          const isActive = tier.name === currentTier.name;
          const isAbove = TIERS.indexOf(tier) > currentIdx;
          return (
            <div
              key={tier.name}
              className={`flex items-center gap-3 px-4 py-2.5 rounded-lg border transition-all ${
                isActive
                  ? 'border-gold-400/50 bg-gold-400/10'
                  : isAbove
                  ? 'border-navy-700/30 bg-navy-800/20 opacity-60'
                  : 'border-emerald-500/20 bg-emerald-500/5'
              }`}
            >
              <div
                className="w-3 h-3 rounded-full flex-shrink-0"
                style={{ backgroundColor: tier.color }}
              />
              <div className="flex-1">
                <span className={`text-sm font-semibold ${isActive ? 'text-gold-400' : 'text-navy-200'}`}>
                  {tier.name}
                </span>
                <span className="text-xs text-navy-500 ml-2">{tier.min}–{tier.max}</span>
              </div>
              {isActive && (
                <span className="text-xs font-bold text-gold-400 px-2 py-0.5 bg-gold-400/10 rounded-full">
                  YOU ARE HERE
                </span>
              )}
              {!isActive && !isAbove && (
                <span className="text-xs text-emerald-400">Achieved</span>
              )}
            </div>
          );
        })}
      </div>

      {/* Next level actions */}
      {currentIdx < TIERS.length - 1 && (
        <div className="bg-navy-800/40 rounded-lg p-4">
          <p className="text-sm font-semibold text-white mb-2">
            To reach <span style={{ color: TIERS[currentIdx + 1].color }}>{TIERS[currentIdx + 1].name}</span> ({TIERS[currentIdx + 1].min}+):
          </p>
          <p className="text-xs text-navy-400 mb-3">Focus on your weakest areas:</p>
          <div className="space-y-2">
            {weakest.map(p => {
              const needed = Math.max(0, TIERS[currentIdx + 1].min * 1.1 - p.score);
              return (
                <div key={p.id} className="flex items-center gap-3">
                  <div className="w-2 h-2 rounded-full bg-red-400 flex-shrink-0" />
                  <span className="text-sm text-navy-200 flex-1">{p.name}</span>
                  <span className="text-xs text-navy-400">{p.score.toFixed(1)}</span>
                  <span className="text-xs text-gold-400">+{needed.toFixed(1)} needed</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
